// src/pages/admin/AddStorehouse.js
import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import {Box} from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import { Button as MuiButton } from '@mui/material';
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export default function AddStorehouse() {
  const navigate = useNavigate();
  const [storehouse, setStorehouse] = useState({
    code: "",
    name: ""
  });

  const addStorehouse = async () => {
    const { code, name } = storehouse;
    if (!code) {
      alert("Please fill in a unique Storehouse Code.");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}common/storehouses`,
        storehouse,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      alert("Storehouse created successfully!");
      navigate("/storehouse-list");
    } catch (error) {
      console.error("Error adding storehouse:", error);
      alert(
        error.response?.data?.message ||
          "Error creating storehouse. Please try again."
      );
    }
  };

  return (
    <PageLayout>
      <Grid container spacing={2} className="align-items-center">
        <Grid size={{ xs: 12, md: 6 }}>
          <Breadcrumb title="Add Storehouse" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} className="text-end">
          <Link to="/storehouse-list">
            <MuiButton variant="contained" color="secondary">Back to List</MuiButton>
          </Link>
        </Grid>
      </Grid>

      <Grid container spacing={2} className="mt-4">
        <Grid size={{ xs: 12 }}>
          <Box className="mc-card">
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }} className="mb-3">
                <CardHeader title="Storehouse Code" />
                <TextField
                  fullWidth
                  placeholder="e.g. HQ1"
                  value={storehouse.code}
                  onChange={(e) =>
                    setStorehouse({ ...storehouse, code: e.target.value.toUpperCase() })
                  }
                />
              </Grid>

              <Grid size={{ xs: 12 }} className="mb-3">
                <CardHeader title="Storehouse Name" />
                <TextField
                  fullWidth
                  placeholder="Optional human-readable name"
                  value={storehouse.name}
                  onChange={(e) =>
                    setStorehouse({ ...storehouse, name: e.target.value })
                  }
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid size={{ xs: 12 }} className="mt-3 d-flex justify-content-end">
          <MuiButton variant="contained" color="primary" onClick={addStorehouse}>
            Create Storehouse
          </MuiButton>
        </Grid>
      </Grid>
    </PageLayout>
  );
}
